import type { DaysResponse } from '@transp/shared'
import { useEffect, useState } from 'react'

export type DaysState =
	| { status: 'loading' }
	| { status: 'error'; message: string }
	| { status: 'ready'; data: DaysResponse }

/** Dias que a demo pode oferecer. Vem do banco, nao de constante: ver queries/days.ts. */
export function useDays(q: { from: string; to: string; lines: string[] }): DaysState {
	const [state, setState] = useState<DaysState>({ status: 'loading' })
	const linesKey = q.lines.join(',')

	useEffect(() => {
		const ctl = new AbortController()
		setState({ status: 'loading' })
		fetch(`/api/dias?de=${q.from}&ate=${q.to}&linhas=${linesKey}`, { signal: ctl.signal })
			.then(async (r) => {
				if (!r.ok) throw new Error(`${r.status}: ${await r.text()}`)
				return (await r.json()) as DaysResponse
			})
			.then((data) => setState({ status: 'ready', data }))
			.catch((err: unknown) => {
				if (ctl.signal.aborted) return
				setState({ status: 'error', message: String(err) })
			})
		return () => ctl.abort()
	}, [q.from, q.to, linesKey])

	return state
}
